module.exports = __webpack_public_path__ + "img/avatar3.8641f762.png";